import * as z from 'zod';

export const paginatedResultSchema = <T extends z.ZodType>(schema: T) =>
  z.object({
    results: z.array(schema),
    totalCount: z.number().int(),
  });
